import React from 'react'
import PropTypes from 'prop-types'
import { SecondaryButton, TransparentBgButton } from './Button'
import { useTranslation } from 'react-i18next'

export default function ConfirmationModal(props) {
  const { title, description, onCancel, onConfirm } = props
  const { t } = useTranslation()

  return (
    <div className='confirm-modal'>
      <div className='confirm-modal_content'>
        <h1>{title}</h1>

        <p>{description}</p>
      </div>

      <div className='confirm-modal_footer'>
        <TransparentBgButton color='navy' text={t('common.cancel')} onClick={onCancel} />

        <SecondaryButton text={t('common.yesProceed')} onClick={onConfirm} />
      </div>
    </div>
  )
}

ConfirmationModal.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
}